var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9248 12.2325H13.7183C13.7183 12.2325 17.6266 16.0095 18.5817 17.0492C19.5367 18.0889 18.1827 19.2857 17.2277 18.4999C16.2727 17.7141 12.2305 13.7202 12.2305 13.7202V12.9267L11.933 12.6292C10.842 13.6211 9.3542 14.2162 7.76726 14.2162C4.19664 14.2162 1.32031 11.3398 1.32031 7.76921C1.32031 4.1986 4.19664 1.32227 7.76726 1.32227C11.3379 1.32227 14.2142 4.1986 14.2142 7.76921C14.2142 9.35615 13.6191 10.8439 12.6273 11.9349L12.9248 12.2325ZM7.75679 12.994C10.6482 12.994 12.9921 10.6501 12.9921 7.75874C12.9921 4.86736 10.6482 2.52344 7.75679 2.52344C4.86541 2.52344 2.52148 4.86736 2.52148 7.75874C2.52148 10.6501 4.86541 12.994 7.75679 12.994Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.a32a7ed6.svg";
export { ForwardRef as ReactComponent };